import { Card, CardMedia, Chip, Box, IconButton, Typography } from '@mui/material';
import { styled } from '@mui/system';

export const ProjectSection = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.sectionPrimaryDark || theme.custom?.gradients?.brand || 'linear-gradient(45deg, #1A2980 0%, #26D0CE 100%)')
    : (theme.custom?.gradients?.sectionPrimaryLight || 'linear-gradient(45deg, #667eea 0%, #764ba2 100%)'),
  clipPath: 'polygon(0 5%, 100% 0%, 100% 95%, 0% 100%)',
}));

export const ProjectCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '20px',
  overflow: 'hidden',
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.glass?.bgDark || 'rgba(255,255,255,0.06)')
    : 'linear-gradient(135deg, #f5f7fa, #c3cfe2)',
  border: theme.palette.mode === 'dark' ? (theme.custom?.glass?.borderDark || '1px solid rgba(255,255,255,0.10)') : '1px solid rgba(0, 0, 0, 0.1)',
  backdropFilter: theme.palette.mode === 'dark' ? (theme.custom?.glass?.blur || 'blur(14px)') : undefined,
  transition: 'all 0.3s cubic-bezier(.25,.8,.25,1)',
  cursor: 'pointer',
  boxShadow: theme.palette.mode === 'dark'
    ? (theme.custom?.shadows?.softDark || '0 15px 30px rgba(0,0,0,0.4), 0 5px 15px rgba(0,0,0,0.3)')
    : '0 15px 30px rgba(0,0,0,0.1), 0 5px 15px rgba(0,0,0,0.07)',
  '&:hover': {
    transform: 'translateY(-10px) scale(1.02)',
    boxShadow: theme.palette.mode === 'dark'
      ? (theme.custom?.shadows?.glowPrimary || '0 20px 40px rgba(0,0,0,0.5), 0 10px 20px rgba(0,0,0,0.4)')
      : '0 20px 40px rgba(0,0,0,0.2), 0 10px 20px rgba(0,0,0,0.1)',
  },
}));

export const ProjectMedia = styled(CardMedia)(({ theme }) => ({
  height: 250,
  position: 'relative',
  overflow: 'hidden',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: theme.palette.mode === 'dark'
      ? 'linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.8))'
      : 'linear-gradient(to bottom, rgba(255,255,255,0), rgba(255,255,255,0.8))',
  },
}));

export const ProjectTitle = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  bottom: 20,
  left: 20,
  color: theme.palette.mode === 'dark' ? 'white' : 'black',
  zIndex: 1,
  fontWeight: 'bold',
  textShadow: theme.palette.mode === 'dark'
    ? '2px 2px 4px rgba(0,0,0,0.5)'
    : '2px 2px 4px rgba(255,255,255,0.5)',
}));

export const TechChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  backgroundColor: theme.palette.mode === 'dark'
    ? 'rgba(255, 255, 255, 0.1)'
    : 'rgba(0, 0, 0, 0.1)',
  color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

export const ModalContent = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  maxWidth: 1200,
  maxHeight: '90vh',
  background: theme.palette.mode === 'dark'
    ? (theme.custom?.gradients?.appBackgroundDark || 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)')
    : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
  boxShadow: theme.palette.mode === 'dark' ? (theme.custom?.shadows?.softDark || '0 30px 60px rgba(0,0,0,0.5)') : '0 30px 60px rgba(0,0,0,0.15)',
  borderRadius: 16,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

export const ModalImage = styled('img')(({ theme }) => ({
  width: '100%',
  height: '300px',
  objectFit: 'cover',
  [theme.breakpoints.up('md')]: {
    width: '50%',
    height: 'auto',
  },
}));

export const ModalInfo = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: theme.spacing(4),
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    width: '50%',
    maxHeight: '90vh',
  },
}));

export const TechIcon = styled('img')({
  width: 40,
  height: 40,
  margin: 8,
});

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: 8,
  top: 8,
  color: theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.grey[700],
  zIndex: 1,
}));
